import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming custom styles are here

const DistrictDetails = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [districtDetails, setDistrictDetails] = useState([
    { district: "Colombo", province: "Western", status: "Active", id: 1 },
    { district: "Gampaha", province: "Western", status: "Inactive", id: 2 },
    { district: "Kandy", province: "Central", status: "Active", id: 3 },
    { district: "Jaffna", province: "Northern", status: "Inactive", id: 4 },
    { district: "Galle", province: "Southern", status: "Active", id: 5 },
  ]);

  const [formData, setFormData] = useState({
    district: "",
    province: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [districtDetails]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedDistrict) {
      setDistrictDetails(
        districtDetails.map((district) =>
          district.id === selectedDistrict.id
            ? { ...formData, id: district.id }
            : district
        )
      );
    } else {
      setDistrictDetails([
        ...districtDetails,
        {
          ...formData,
          id: districtDetails.length
            ? districtDetails[districtDetails.length - 1].id + 1
            : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ district: "", province: "", status: "Active" });
    setSelectedDistrict(null);
  };

  const handleEdit = (district) => {
    setSelectedDistrict(district);
    setFormData({
      district: district.district,
      province: district.province,
      status: district.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedDistrict(null);
    setFormData({ district: "", province: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="district-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left-side Form Panel */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "320px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedDistrict ? "Edit District" : "Add District"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>District:</label>
              <input
                type="text"
                name="district"
                value={formData.district}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Province:</label>
              <input
                type="text"
                name="province"
                value={formData.province}
                onChange={handleChange}
                required
                className="form-control"
                placeholder="E.g. Western, Central"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Table Section */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>District Details (Sri Lanka)</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add District
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>District</th>
                  <th>Province</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {districtDetails.map((district) => (
                  <tr key={district.id}>
                    <td>{district.district}</td>
                    <td>{district.province}</td>
                    <td>
                      <span
                        className={`badge ${
                          district.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {district.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(district)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DistrictDetails;
